export default __webpack_public_path__ + "static/media/bulk-assignment.7eae1a3b.svg";